import React from 'react';
import { connect } from 'react-redux';
import UnlockPremium from './UnlockPremium'
import { Modal, Button as AButton, Row } from 'antd';
import { CheckIcon } from '../core/icons'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'

import styled from 'styled-components'

import { push, goBack } from 'react-router-redux'

import Accounts from '../account/bank-card/Accounts'
import {importTxnStatus} from '../account/bank-card/actions'


export const Button = styled(AButton).attrs({
  type: props => props.primary && 'primary'
})`
  font-size: 18px;
  margin-top: 12px;

  ${props=>props.fullWidth&&`
    width: 100%;
    height: 42px;
  `}
`

const Body = styled.div`
  padding: 5vmin;
  font-size: large;
  h1 {
    font-size: 25px;
    text-transform: capitalize;

  }
  > ol {
    list-style: decimal;
    padding-left: 30px;
    li {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 1vmin 0;
    }
  }
`

const BankCardSyncModal = ({ dispatch, message, title, buttonText, tokenId }) => (
  <Modal
    size='large'
    bodyStyle={{padding: 0}}
    visible={true}
    footer={null}
  >
    <Body>
      <h1>{title}</h1>
      <p>{message}</p>
      <Accounts
        tokenId={tokenId}
      />
      <Row justify="end" type="flex">
        <Button primary onClick={() =>{
          dispatch({type:'HIDE_MODAL_2'})
          dispatch(push('/transactions'))
          dispatch(importTxnStatus())
        }}>{buttonText}</Button>
      </Row>
    </Body>
  </Modal>

)


export default connect(
  // mapStateToProps,
  // mapDispatchToProps
)(BankCardSyncModal)



// WEBPACK FOOTER //
// ./src/modal/BankCardSyncModal.js